import React from 'react'
import { Tooltip } from '../../Tooltip/Tooltip'

export interface EditorCommandButtonProps
  extends Omit<
    React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>,
    'title'
  > {
  title?: string
  activeClassName?: string
  isActive?: () => boolean
}

export const EditorCommandButton = React.forwardRef(
  (
    {
      title,
      isActive,
      children,
      className = 'btn',
      activeClassName = 'btn-body-secondary',
      style,
      ...props
    }: React.PropsWithChildren<EditorCommandButtonProps>,
    ref: React.Ref<HTMLButtonElement>,
  ) => {
    if (className.includes('btn')) {
      style = {
        ...style,
        borderRadius: '0.5rem',
        padding: '0.1875rem 0.375rem',
      }
    }
    return (
      <button
        ref={ref}
        {...props}
        type="button"
        name={props.name || title?.toLowerCase().replace(/[^a-z0-9]+/g, '-')}
        className={`${className} ${!!isActive?.() ? activeClassName : 'btn-link text-body'}`.trim()}
        style={style}
      >
        {!!title && (
          <Tooltip title={title} placement="top" offsetOptions={5}>
            {children}
          </Tooltip>
        )}
        {!title && children}
      </button>
    )
  },
)
